var StageAlign = /** @class */ (function () {
    function StageAlign() {
    }
    StageAlign.BOTTOM = 'B';
    StageAlign.BOTTOM_LEFT = 'BL';
    StageAlign.BOTTOM_RIGHT = 'BR';
    StageAlign.LEFT = 'L';
    StageAlign.RIGHT = 'R';
    StageAlign.TOP = 'T';
    StageAlign.TOP_LEFT = 'TL';
    StageAlign.TOP_RIGHT = 'TR';
    return StageAlign;
}());
export { StageAlign };
